import {
  Component,
  Input,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Column } from '../../model/common/column';
import { BaseGridComponent } from './base-grid.component';
import { TableModule } from '@openng/optimus-ui/table';
import {
  NgClass,
  LowerCasePipe,
  DecimalPipe,
  CurrencyPipe,
  DatePipe,
} from '@angular/common';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ExportComponent } from './export.component';
import { TableColumnHeaderComponent } from './table-column-header.component';
import { TableFilterComponent } from './table-filter.component';
import { ButtonDirective } from '@openng/optimus-ui/button';
import { Checkbox } from '@openng/optimus-ui/checkbox';
import { FormsModule } from '@angular/forms';
import { NoteEntryStringPipe } from '../../pipes/note-entry-string.pipe';
import { Clipboard } from '@angular/cdk/clipboard';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

@Component({
  selector: 'app-general-grid',
  templateUrl: './general-grid.component.html',
  styleUrls: ['./general-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TableModule,
    PrimeTemplate,
    TranslateDirective,
    ExportComponent,
    TableColumnHeaderComponent,
    TableFilterComponent,
    ButtonDirective,
    NgClass,
    Checkbox,
    FormsModule,
    LowerCasePipe,
    DecimalPipe,
    CurrencyPipe,
    DatePipe,
    TranslatePipe,
    NoteEntryStringPipe,
    TooltipModule,
  ],
})
export class GeneralGridComponent
  extends BaseGridComponent<object>
  implements OnInit
{
  protected _clipboard = inject(Clipboard);

  /**
   * The total number of records returned from the search result
   */
  //@ts-ignore
  @Input() totalRecords: number = 50;

  //@ts-ignore
  @Input() columns: any[] = [];

  //@ts-ignore
  @Input() rows: number = 50;

  /**
   * This input is to enable or disable the grid's filterable option
   */
  readonly filterable = input(true);

  /**
   * This input is to enable or disable the grid's paginator option
   */
  readonly usePaginator = input(true);

  /**
   * This input is to set the grid's rows per page options if paginator is used
   */
  readonly rowsPerPageOptions = input<number[]>([]);

  /**
   * This input is to enable or disable the grid's row expand option
   */
  readonly useRowExpand = input(false);

  /**
   * This input is to set the max grid's height prior the use of scroll bar
   */
  readonly scrollHeight = input('auto');

  /**
   * This input is to display or hide export button
   */
  @Input() includeExportCSV = true;

  /**
   * This input is to allow setting a custom white space style
   */
  readonly whiteSpaceStyle = input('nowrap');

  readonly rowExpand = output<any>();
  readonly changeViewEvent = output<any>();
  readonly actionButtonEvent = output<any>();
  readonly rowDblClickEvent = output<any>();
  readonly filterEvent = output<any>();

  readonly lazy = input(true);

  readonly pageLinkSize = input(5);
  readonly virtualScroll = input(false);

  readonly alwaysShowPaginator = input(true);

  ngOnInit() {
    this.responsive = true;
  }

  getStyleClass(col: Column) {
    let style = '';
    if (!col.frozen) {
      style += 'ui-resizable-column ';
    }

    if (col.formatPattern === 'number') {
      style += 'number-column';
    }

    return style;
  }

  changeView($event: Event, data: { data: object; type?: any }): void {
    $event.preventDefault();
    this.changeViewEvent.emit(data);
  }

  executeActionButton($event: Event, data: { data: object; type?: any }): void {
    $event.preventDefault();
    this.actionButtonEvent.emit(data);
  }

  isMobileDevice() {
    return this._deviceService.isMobile();
  }

  copyRowText(text: string | undefined) {
    if (text) {
      this._clipboard.copy(text);
    }
  }
}
